import { Grid, Typography, Box, Stack, TextField } from "@mui/material";
import { useForm } from "../../../../providers/FormProvider";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";
import { MissionEnums } from "../../../../common/constants";


const useStyles = makeStyles()(
  (theme) => ({
    root: {
      width: "100%"
    },
    messageSpacing: {
      marginTop: theme.spacing(1)
    },
    missionTypeOption: {
      position: "relative",
      width: "100%",
      padding: theme.spacing(1.5),
      borderRadius: theme.spacing(1.5),
      background: theme.palette.background.grey,
      minHeight: "100%",
      userSelect: "none",
      cursor: "default",
      "&.selected": {
        outline: `2px solid ${theme.palette.secondary.main}`,
      },
      "&.disabled": {
        "&:after": {
          zIndex: 100,
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          background: theme.palette.action.hover,
          borderRadius: theme.spacing(1.5),
          content: "''",
          display: "block",
          pointerEvents: "none"
        },
      },
      "&:hover": {
        "&:after": {
          zIndex: 100,
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          background: theme.palette.action.hover,
          borderRadius: theme.spacing(1.5),
          content: "''",
          display: "block",
          pointerEvents: "none"
        },
      },
    }
  })
);

export default function MissionTypeSection() {
  const { classes } = useStyles();
  const { missionType, setMissionType, form, message, setMessage, disableMissionTypeSelect, locked } = useForm();
  const { t } = useTranslation();

  return (
    <Stack className={classes.root} spacing={1}>

      <Typography variant="h6">
        {t("advancedForm:missionTypeSection:title")}
      </Typography>

      <Box>
        <Grid container spacing={1} alignItems="space-between">

          {
            form.enableSalvageMissions && !disableMissionTypeSelect ? (
              <Grid item xs={4}>
                <MissionTypeOption
                  disabled={locked}
                  title={t("advancedForm:missionTypeSection:salvageTitle")}
                  description={t("advancedForm:missionTypeSection:salvageDescription")}
                  className={classes.missionTypeOption}
                  selected={missionType === MissionEnums.Type.Salvage}
                  onClick={() => setMissionType(MissionEnums.Type.Salvage)}
                />
              </Grid>
            ) : null
          }

          {
            form.enableTowingMissions && !disableMissionTypeSelect ? (
              <Grid item xs={4}>
                <MissionTypeOption
                  disabled={locked}
                  title={t("advancedForm:missionTypeSection:towingTitle")}
                  description={t("advancedForm:missionTypeSection:towingDescription")}
                  className={classes.missionTypeOption}
                  selected={missionType === MissionEnums.Type.Towing}
                  onClick={() => setMissionType(MissionEnums.Type.Towing)}
                />
              </Grid>
            ) : null
          }

          {
            form.enableOtherMissions && !disableMissionTypeSelect ? (
              <Grid item xs={4}>
                <MissionTypeOption
                  disabled={locked}
                  title={t("advancedForm:missionTypeSection:otherTitle")}
                  description={t("advancedForm:missionTypeSection:otherDescription")}
                  className={classes.missionTypeOption}
                  selected={missionType === MissionEnums.Type.Other}
                  onClick={() => setMissionType(MissionEnums.Type.Other)}
                />
              </Grid>
            ) : null
          }

          <Grid item xs={12}>
            <TextField
              className={!disableMissionTypeSelect ? classes.messageSpacing : undefined}
              label={t("advancedForm:missionTypeSection:message")}
              variant="filled"
              value={message}
              onChange={ev => setMessage(ev.target.value)}
              fullWidth
              multiline
              minRows={2}
              size="small"
              disabled={locked}
            />
          </Grid>


        </Grid>
      </Box>

    </Stack >
  );
}


function MissionTypeOption(props) {
  const { className, title, description, onClick, selected, disabled } = props;

  return (
    <Box className={`${className} ${selected ? "selected" : ""} ${disabled ? "disabled" : ""}`} onClick={disabled ? undefined : onClick}>
      <Typography variant="subtitle2">{title}</Typography>
      <Typography variant="body2" color="textSecondary">{description}</Typography>
    </Box>
  );
}


